var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('BaseImg',{attrs:{"option":{
    style: {
      margin: '12px 0 0 16px',
      alignSelf: 'flex-start',
      width: '89px',
    },
    url: 'logo.png',
  }}}),_c('div',{staticClass:"mh-wrap"},[_c('div',{staticClass:"count"},[_c('div',{staticClass:"line"}),_c('div',[_vm._v("剩余抽奖次数："),_c('span',[_vm._v(_vm._s(_vm.gameCount))])])]),_c('div',{staticClass:"mh-box"},_vm._l((3),function(index){return _c('div',{key:index},[_c('img',{attrs:{"src":(_vm.imgHost + "draw_box1.png?v=" + (_vm.$config.OSSVersion))}})])}),0)]),_c('div',{staticClass:"draw-btn",on:{"click":function($event){return _vm.goDraw()}}},[_vm._v("点击抽奖")]),_c('BaseBtnHome')],1)}
var staticRenderFns = []

export { render, staticRenderFns }